/**
 *	nearby-shops.ctrl.js
 */

class NearbyShopsCtrl {
    constructor($scope, $state) {
        this.$state = $state;
    }

    go(item) {
    	this.$state.go('shop-details', {
    		district: item.district,
    		city: item.city,
    		name: item.shopUrl.match("nume\/(.*)\/cod")[1],
            code: item.shopUrl.match("cod\/(.*)")[1]
    	});
    }
}

NearbyShopsCtrl.$inject = ['$scope', '$state'];

export default NearbyShopsCtrl;